import { render, staticRenderFns } from "./InstructionViewInspector.vue?vue&type=template&id=187dcf90&scoped=true"
import script from "./InstructionViewInspector.vue?vue&type=script&lang=js"
export * from "./InstructionViewInspector.vue?vue&type=script&lang=js"
import style0 from "./InstructionViewInspector.vue?vue&type=style&index=0&id=187dcf90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187dcf90",
  null
  
)

export default component.exports